import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import MyMultiSelect from '../../components/MyMultiSelect';
import * as API from '../../framework/API/api';
import { ENTITYNAME, TOAST_TYPES, TRANSMISSION_PUBLISH_STATUS } from '../../framework/constant/constant';
import { useTranslation } from '../../locale/useTranslation';
import NodeTreeViewForm from '../../modules/MediaLibrary/NodeTreeView/NodeTreeViewForm';
import { EditPageHeader } from '../../components/EditPageHeader';
import CollectionSelection from '../forms/CollectionSelection';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { utility } from '../utility/utilityProvider';
import ToastNotification from '../../components/ToastNotification';

const CreateTransmissionForm = (props) => {

    const { onClose, onSubmit, item = {}, isEditMode = false, isFromTransmission = false } = props;

    const lang = useTranslation();

    const [catalogues, setCatalogues] = useState([]);
    const [parentNodes, setParentNodes] = useState([]);
    const [ottPlatforms, setOttPlatforms] = useState([]);
    const [transmissionTypes, setTransmissionTypes] = useState([]);

    const blankDataItem = {
        Catalogue: {},
        ParentNodes: [],
        Nodes: [],
        TransmissionType: {},
        Ott_Platforms: [],
        AutoCreateNode: false
    }
    const [dataItem, setDataItem] = useState((item && Object.keys(item)?.length > 0) ? item : blankDataItem);
    const [showNodePopup, setShowNodePopup] = useState(false);
    const [showOfferSelectionCollection, setShowOfferSelectionCollection] = useState(false);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {

        let catalogueRes = await API.getDataLookup(ENTITYNAME.Catalogues, { query: ["Archive", "!=", true] });
        setCatalogues(catalogueRes?.data ?? []);
        let ottPlatformRes = await API.getDataLookup(ENTITYNAME.Platform, { query: ["Archive", "!=", true] });
        setOttPlatforms(ottPlatformRes?.data ?? []);

        let parentNodeRes = await API.getDataLookup(ENTITYNAME.Nodes, { query: ["Archive", "!=", true] });
        parentNodeRes = parentNodeRes?.data ?? [];
        let root = parentNodeRes?.filter((n) => !n.ParentNode);
        const vodMap = new Map();
        const searchChild = (parent) => {
            parentNodeRes?.forEach(n => {
                if (n?.ParentNode == parent._id) {
                    vodMap.set(parent._id, parent);
                    searchChild(n);
                }
            });
        }
        root?.forEach(n => {
            searchChild(n);
        })
        const vodChannelsArray = Array.from(vodMap.values());
        setParentNodes(vodChannelsArray);

        let itemProviders = item?.MediaEpisode?.Provider?._id ?? null;
        let parentNodes = itemProviders ? parentNodeRes.filter(n => n?.Providers?.includes(itemProviders)) : [];
        let catalogue = (itemProviders && parentNodes.length > 0) ? parentNodes[0].Catalogue : catalogueRes?.data?.[0] ?? {};
        let transmissionTypeRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes, { sort: { SID: 1 } });
        setTransmissionTypes(transmissionTypeRes.data);

        if (!isEditMode) {
            setDataItem({
                ...dataItem,
                Catalogue: catalogue,
                Ott_Platforms: item?.SegmentExtension?.platforms ?? utility.getDefaultItems(ottPlatformRes?.data),
                TransmissionType: item?.TransmissionType ?? transmissionTypeRes?.data?.[0] ?? {},
                ParentNodes: parentNodes,
                Nodes: [],
                AutoCreateNode: false,
            });
        }
    }

    const onChange = (e) => {
        if (e.target.name === 'AutoCreateNode') {
            setDataItem({ ...dataItem, AutoCreateNode: !dataItem.AutoCreateNode });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const handleSelectedNodes = (nodes) => {

        setDataItem(prev => {
            const merged = [...(prev.Nodes || []), ...nodes];
            const unique = Array.from(
                new Map(merged.map(item => [item._id, item])).values()
            );

            return {
                ...prev,
                Nodes: unique
            };
        });



        setShowNodePopup(false);
    }

    const handleOffersSelected = (dataList) => {
        setDataItem({ ...dataItem, Offers: dataList });
    }

    const isValid = () => {
        if (!dataItem.Catalogue || Object.keys(dataItem.Catalogue).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_catalogue_error_message });
            return false;
        }
        if (dataItem.ParentNodes.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_channels_error_message });
            return false;
        }
        if (!dataItem.AutoCreateNode && dataItem.Nodes?.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_nodes_error_message });
            return false;
        }

        if (isFromTransmission && (!dataItem.TransmissionType || Object.keys(dataItem.TransmissionType).length === 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_selest_transmission_type_error_message });
            return false;
        }

        if (!dataItem.Ott_Platforms.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_ott_platform });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        let finalData = {
            ...(!isEditMode ? {} : item),
            Offers: dataItem?.Offers,
            Catalogue: dataItem?.Catalogue ? { _id: dataItem?.Catalogue._id, Description: dataItem?.Catalogue?.Description } : {},
            ParentNodes: dataItem?.ParentNodes,
            Nodes: dataItem?.Nodes,
            Ott_Platforms: dataItem?.Ott_Platforms,
            TransmissionType: dataItem?.TransmissionType,
            AutoCreateNode: dataItem?.AutoCreateNode ?? false
        }
        onSubmit(finalData);
    }

    return (
        <BossDialog title="Create Transmissions" width='400px' onClose={onClose}>
            <EditPageHeader showTitle={false} saveButtonTitle={lang.save_button_text} onSubmit={handleSubmit} onCancel={onClose} />
            <div className='row'>
                <div className='col-12 mt-2'>
                    <label>{lang.catalogue_label} *</label>
                    <DropDownList
                        data={catalogues}
                        name="Catalogue"
                        dataItemKey="_id"
                        textField="Description"
                        value={dataItem.Catalogue}
                        onChange={onChange}
                    />
                </div>
                <div className='col-12 mt-2'>
                    <label>{lang.vod_channels_label} *</label>
                    <MyMultiSelect
                        data={dataItem.Catalogue && dataItem.Catalogue._id ? parentNodes.filter((x) => x.Catalogue._id == dataItem.Catalogue._id) : []}
                        name="ParentNodes"
                        dataItemKey="_id"
                        textField="Name"
                        value={dataItem.ParentNodes}
                        onChange={onChange}
                    />
                </div>
                <div className='col-12 mt-2'>
                    <label>{lang.nodes_label} {dataItem?.AutoCreateNode ? "" : "*"}</label>
                    <div className='d-flex'>
                        <MyMultiSelect
                            data={[]}
                            name="Nodes"
                            dataItemKey="_id"
                            textField="Name"
                            style={{ flex: 1, width: "320px", marginRight: "10px" }}
                            value={dataItem.Nodes}
                            onChange={onChange}
                        />
                        <button
                            type="button"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                            style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                            onClick={() => setShowNodePopup(true)}
                            title={lang.attach_nodes_button_tooltip}
                            disabled={dataItem?.ParentNodes?.length == 0}
                        >
                            <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div className='col-12 mt-2'>
                    <input
                        style={{ border: "1px solid grey" }}
                        name="AutoCreateNode"
                        type='checkbox'
                        onChange={onChange}
                    />
                    <label className="ml-2">{lang.auto_create_nodes_label}</label>
                </div>
                {isFromTransmission && <div className='col-12 mt-2'>
                    <label>{lang.transmission_type_label} *</label>
                    <DropDownList
                        data={transmissionTypes}
                        name="TransmissionType"
                        dataItemKey="_id"
                        textField="Name"
                        value={dataItem.TransmissionType}
                        onChange={onChange}
                    />
                </div>}
                <div className='col-12 mt-2'>
                    <label>{lang.platform_label} *</label>
                    <MyMultiSelect
                        data={ottPlatforms}
                        name="Ott_Platforms"
                        dataItemKey="_id"
                        textField="Description"
                        value={dataItem.Ott_Platforms}
                        onChange={onChange}
                    />
                </div>
            </div>
            {showNodePopup && <BossDialog title={lang.select_nodes_dialog_header} width='600px' onClose={() => setShowNodePopup(false)}>
                <NodeTreeViewForm selectedNodeIds={dataItem?.ParentNodes?.map(n => n?._id) ?? []} isSaveButton={true} isMultiSelect={false} onClose={() => setShowNodePopup(false)} handleSelectedNodes={handleSelectedNodes} showCatalogue={false} isFromMedia={true} />
            </BossDialog>}
            {showOfferSelectionCollection && <CollectionSelection title={lang.select_offers_label} entityname={ENTITYNAME.OFFER} setDataList={handleOffersSelected} closeForm={() => setShowOfferSelectionCollection(false)} mode={'multiple'} width={"50vw"} showCreate={true} path={`/home/offer`} showVODType={true} />}
        </BossDialog>
    )
}

export default CreateTransmissionForm